import React from 'react';
export function BotanicalDivider() {
  return <div className="w-full flex justify-center py-12 opacity-40 pointer-events-none" data-id="element-25">
      <svg width="120" height="24" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-26">
        <path d="M60 12C60 12 55 2 45 2C35 2 30 12 30 12C30 12 35 22 45 22C55 22 60 12 60 12Z" fill="#6B8F71" data-id="element-27" />
        <path d="M60 12C60 12 65 2 75 2C85 2 90 12 90 12C90 12 85 22 75 22C65 22 60 12 60 12Z" fill="#6B8F71" data-id="element-28" />
        <path d="M20 12H100" stroke="#6B8F71" strokeWidth="1.5" strokeLinecap="round" data-id="element-29" />
      </svg>
    </div>;
}